// extracted by mini-css-extract-plugin
module.exports = {"text":"readmore_text__2-cQe","readorhide":"readmore_readorhide__21Kc1"};